import { render, staticRenderFns } from "./PillList.vue?vue&type=template&id=276f2ed5&lang=pug&"
import script from "./PillList.vue?vue&type=script&lang=js&"
export * from "./PillList.vue?vue&type=script&lang=js&"
import style0 from "./PillList.vue?vue&type=style&index=0&id=276f2ed5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports